// Copyright (c) 2019 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { FormattedMessage, WrappedComponentProps, injectIntl } from "react-intl";
import { Button } from "react-bootstrap";

import { RoutedProps, withRouter } from "view/reactrouterinterceptor";
import { ActionType, IAction, IActionSortTable, raiseAction } from "actions";
import { IState } from "states/states";
import { UserRole } from "graphql/api";

import ConditionList from "view/comp/ConditionList";
import ModuleList from "view/comp/ModuleList";

interface IModulesConditionsProps {
  showConditions: boolean;
  showModules: boolean;
}

const mapStateToProps = (state: IState) => {
  const curUser = state.site.userList?.find((curItem) => curItem.secId === state.site.user?.secId);

  const props: IModulesConditionsProps = {
    showConditions:
      Boolean(curUser?.accessRights.controllerAdmin) && Boolean(state.parameter?.condition.length),
    showModules:
      Boolean(curUser?.accessRights.controllerAdmin) && Boolean(state.parameter?.module.length),
  };
  return props;
};

interface IModulesConditionsDispatch {
  onSort: (sort: IActionSortTable) => void;
}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IModulesConditionsDispatch = {
    onSort: (sort: IActionSortTable) => {
      dispatch(raiseAction(ActionType.ACT_SORT_TABLE, sort));
    },
  };
  return dispatchProps;
};

class ModulesConditionsComponent extends React.Component<
  IModulesConditionsProps & IModulesConditionsDispatch & WrappedComponentProps & RoutedProps
> {
  public render() {
    return (
      <div id="modulesconditions">
        {this.renderBackButton()}
        {this.props.showModules && <ModuleList />}
        {this.props.showConditions && <ConditionList />}
      </div>
    );
  }

  private renderBackButton() {
    return (
      <div className="buttonbar d-print-none">
        <Button id="navigate-back" variant="secondary" onClick={() => this.props.navigate(-1)}>
          <FormattedMessage id="Back to Last View" />
        </Button>
      </div>
    );
  }
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(ModulesConditionsComponent)),
);
